import { useState, useEffect } from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

interface ScaleStepProps {
  title: string;
  value: string;
  onChange: (value: string) => void;
}

export const ScaleStep = ({ title, value, onChange }: ScaleStepProps) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Reset selected value when title changes (i.e., when moving to next question)
  useEffect(() => {
    setSelectedValue(null);
  }, [title]);

  const handleValueChange = (newValue: string) => {
    setSelectedValue(newValue);
    setIsTransitioning(true);
    setTimeout(() => {
      onChange(newValue);
      setIsTransitioning(false);
    }, 500);
  };

  // Get emoji based on question type
  const getQuestionEmoji = () => {
    if (title.toLowerCase().includes('introvert')) {
      return '🌙';
    } else if (title.toLowerCase().includes('creative')) {
      return '✨';
    }
    return '';
  };

  return (
    <div className="space-y-8 py-4">
      <h2 className="text-xl font-semibold font-nexa mb-12 flex items-center justify-center gap-2">
        {getQuestionEmoji()} {title}
      </h2>
      <div className="relative">
        <div className="absolute -top-6 left-0 text-sm text-muted-foreground">
          Strongly Disagree
        </div>
        <RadioGroup
          value={selectedValue || ""}
          onValueChange={handleValueChange}
          // className="grid grid-cols-5 gap-2 md:grid-cols-10"
          className="flex flex-row gap-2 justify-center flex-wrap md:flex-nowrap py-4"
        >
          {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
            <div key={num} className="flex flex-col items-center space-y-1 md:space-y-2">
              <RadioGroupItem
                value={num.toString()}
                id={`r${num}`}
                className={`size-6 md:size-10 border-2 border-primary transition-all duration-200
                  ${selectedValue === num.toString() 
                    ? "border-secondary bg-primary" 
                    : "bg-transparent"}`}
                disabled={isTransitioning}
              />
              <Label htmlFor={`r${num}`} className="text-sm">
                {num}
              </Label>
            </div>
          ))}
        </RadioGroup>
        <div className="absolute -bottom-8 right-0 text-sm text-muted-foreground">
          Strongly Agree
        </div>
      </div>
    </div>
  );
};